import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.deleteAccount.loading;
export const selectErrorMessage = (state: RootState) =>
  state.deleteAccount.error;
export const deleteAccountDataResponse = (state: RootState) =>
  state.deleteAccount.deleteAccountResponse;
